import * as React from "react";
import { PT_ProtectiveFunction } from "../models/PT_ProtectiveFunction";
import { DeviceData } from "../models/DeviceData";
import { Message } from "../models/ProtectiveFunctionWrapper";

interface Props {
    x: string;
    y: string;
    boxSize: string;
    imgWidth: string;
    imgHeight: string;
    device?: DeviceData;
    type: "Device" | "SSS" | "LSS" | "ManualActionDevice" ;
    handleDeviceClicked: (device: DeviceData, type: string) => void;
    handleManualActionDeviceRightClicked: (e: React.MouseEvent) => void;
    errorsAndWarnings?: Message[];
}

const ManualActionDevice = (props: Props) => {
    if (props.device == null) {
        return null;
    }

    const type = props.type;
    var hasWarning = false;
    var hasError = false;
    var errorsAndWarningsText = "";
    if (props.errorsAndWarnings) {
        hasWarning = props.errorsAndWarnings.some(x => x.messageType === 'warning');
        hasError = props.errorsAndWarnings.some(x => x.messageType === 'error');
        errorsAndWarningsText = props.errorsAndWarnings.map(x => x.formatMessageById(props.device.ptProtectiveFunction.guiLocation)).join('\n');
    }

    return (
        <div
            title={errorsAndWarningsText}
            className={`${type} ${hasWarning ? "warning-message" : ""} ${hasError ? "error-message" : ""}`}
            style={{ zIndex: 1000, left: props.x, top: props.y, width: props.boxSize, height: props.boxSize, display: "block", position: "absolute", pointerEvents: "all" }} onClick={(event: React.MouseEvent) => props.handleDeviceClicked(props.device, type)} onContextMenu={(e: React.MouseEvent) => props.handleManualActionDeviceRightClicked(e)} >
            {props.device.ptProtectiveFunction
          ? <img src={`/HTMLImages/device/UsrCtaction.bmp`} style={{ left: props.x, top: props.y, width: props.imgWidth, height: props.imgHeight }} />
                : null
            }
        </div>
    );
};

export default ManualActionDevice;